// extracted by mini-css-extract-plugin
module.exports = {"margin":"styles_margin__3leD2","filter":"styles_filter__VOPMx","desktop":"styles_desktop__1mOFP","module":"styles_module__x1lG1","mobile":"styles_mobile__2y6KZ"};